import { tw } from 'utils/classnames'

type SeparatorProps = React.ComponentProps<'hr'> & {
  orientation?: 'horizontal' | 'vertical'
}

export function Separator(props: SeparatorProps) {
  return (
    <hr
      className={tw(
        'bg-gray-700',
        props.orientation === 'vertical' ? 'h-full w-[1px]' : 'h-[1px] w-full',
        props.className,
      )}
    />
  )
}
